angular
  .module('common.directives')
  .directive('multipleBroadcastVideosV2', function () {
    return {
      scope: {
        organizationId: '='
      },
      templateUrl:
        './templates/multiple.broadcast.videos.views.html?t=' + webpackHash,
      controller: 'multipleBroadcastVideosCtrl',
      link: function ($scope, $element) {}
    }
  })
